module.exports = __webpack_public_path__ + "media/assets/images/flags/nf-55fe473de8a68475c0937441a461ce35.svg";